import form from "./schemas/form";
import validations from "./schemas/validations";
import {useEffect, useState} from "react";
import initialValues from "./schemas/initialValues";
import axios from "axios";
import {API_URL} from "../../../config";
import {capitalizeFirstLetter} from "../../../helpers/helpers";
import {useParams} from 'react-router-dom';

const useEditTable = () => {

    const { id } = useParams();

    const {formId, formField} = form;
    const currentValidation = validations;

    const [values, setValues] = useState(initialValues);

    const [isLoading, setIsLoading] = useState(true);

    const [snackbarConfig, setSnackbarConfig] = useState({
        color: 'success',
        title: '',
        message: '',
        icon: 'notifications'
    });
    const [show, setShow] = useState(false);
    const toggleSnackbar = () => setShow(!show);

    useEffect(() => {

        const init = async () => {

            setIsLoading(true);

            await loadRecord();

            setIsLoading(false);
        };

        init();

    }, []);

    const loadRecord = async () => {

        try {

            const response = await axios.get(`${API_URL}/tables/${id}`);

            setValues(response.data);

        } catch (error) {

            setSnackbarConfig({
                message: "Something went wrong loading the table's details",
                icon: 'cancel',
                title: 'Tables',
                color: 'warning'
            });

            setShow(true);

        }

    };

    const handleSubmit = async (values, actions) => {

        try {

            // Enviar datos a API
            await axios.put(
                `${API_URL}/tables/${id}`,
                {...values}
            );

            setSnackbarConfig({
                message: 'Table updated successfully',
                icon: 'notifications',
                title: 'Tables',
                color: 'success'
            });

            setShow(true);

        } catch (error) {

            setSnackbarConfig({
                message: error.response.data.message,
                icon: 'cancel',
                title: 'Tables',
                color: 'warning'
            });

            setShow(true);

        }

        actions.setSubmitting(false);

    };

    return {
        formId,
        formField,
        currentValidation,
        values,
        isLoading,
        snackbarConfig,
        show,
        toggleSnackbar,
        handleSubmit
    }
};

export default useEditTable;
